module.exports = __webpack_public_path__ + "img/搜索因子库.72e95e41.png";